import { formatName } from "@api";
import type { IUser } from "@bbj-types/user";
import { Avatar, Tooltip, Zoom } from "@mui/material";
import { UserChipStyled, classes } from "./styles";

interface IUserChip {
  users: Pick<IUser, "firstName" | "lastName">[];
  maxUsers: number;
  disabled?: boolean;
}

const formatSurplusTooltip = (users: Pick<IUser, "firstName" | "lastName">[], maxUsers: number) => {
  // biome-ignore lint/style/useBlockStatements: <explanation>
  if (users.length < maxUsers) return;

  let title = formatName(users[maxUsers - 1]);

  for (let i = maxUsers; i < users.length; i++) {
    title += `, ${formatName(users[i])}`;
  }

  return title;
};

export const UserChip = ({ users, maxUsers, disabled }: IUserChip) => {
  return (
    <UserChipStyled
      data-hj-suppress="true"
      className={`${classes.root} ${disabled ? classes.disabled : ""}`}
      max={maxUsers}
      renderSurplus={(surplus) => (
        <Tooltip data-hj-suppress="true" title={formatSurplusTooltip(users, maxUsers)} arrow slots={{
          transition: Zoom
        }}>
          <span>+{surplus}</span>
        </Tooltip>
      )}
      total={users.length}
    >
      {users.map((user) => (
        <Tooltip
          data-hj-suppress="true"
          key={`${user.firstName}-${user.lastName}`}
          title={formatName(user)}
          arrow
          slots={{
            transition: Zoom
          }}
        >
          <Avatar>
            {user.firstName?.[0]?.toUpperCase()}
            {user.lastName?.[0]?.toUpperCase()}
          </Avatar>
        </Tooltip>
      ))}
    </UserChipStyled>
  );
};
